import React from 'react';
import { Prompt } from 'react-router-dom';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Button from '../../../../components/atomic/Buttons/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import FileUploader from '../../../../components/atomic/Inputs/FileUploader';
import { AlertModal } from '../../../../components/molecule/Modals/AlertModal';
import Icon from '@material-ui/core/Icon';
import * as apiServices from '../../../../services/apiServices';
import { toast } from 'react-toastify';

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`
const StretchContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const VideoContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${'' /* min-width: 200px;
  max-width: 200px;
  height: 100%; */}
  // background: rgba(0,0,0,0.1);
  flex: 1;
  // margin: 3px;
  overflow: hidden;
`

const ItemContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  // height: 200px;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
`
const ButtonStyled = styled(Button)`
  margin-left: 8px;
`
const FormStyled = styled(Form)`
  display: flex;
  flex-direction: column;
`
const UploadButtonContainer = styled.div`
  // margin: 3px;
`
const RemoveIconStyled = styled(Icon)`
  color: white;
`

const UploadProgressContainer = styled.div`
  margin-top: 8px;
  width: 100%;
`

const DropContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: flex-end;
  height: 1px;
  z-index: 1;
`

const RemoveIconButton = styled(Button)`
  position: absolute;
  padding: 0;
  right: 0;
  // min-width: 40px;
  // max-width: 40px;
  height: 40px;
`

class ChannelImageForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      imageUploadProgress: 0,
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  manualSubmit = () => {
    const { submitExerciseForm } = this.props;
    submitExerciseForm();
  }

  removeImage = () => {
    const { setBackdropImage } = this.props;
    this.changeTracker({url: null},'channel_image');
    setBackdropImage(null);
  }

  imageUploadFinished = ({ awsUrl }) => {
    const { setBackdropImage } = this.props;
    apiServices.addOverviewImage({ url: awsUrl })
      .then(data => {
        toast.success('image uploaded successfully');
        this.changeTracker({id: data.id, url: data.url}, 'channel_image');
        setBackdropImage(data.url);
        this.setState({ imageUploadProgress: 0 });
      });
  }
  updateImageUploadProgress = (imageUploadProgress) => {
    this.setState({ imageUploadProgress });
  }

  render () {
    const {
      values,
      onClickCancel,
      dirty,
    } = this.props
    const { imageUploadProgress } = this.state;
    return (
      <FormStyled>
        <Container>
          <StretchContainer>
            <VideoContainer>
              <ItemContainer>
              {
                  values.channel_image &&
                  <DropContainer>
                    <RemoveIconButton variant='contained' color="secondary" onClick={() => AlertModal('Delete Image','Are you sure you want to delete this image?', this.removeImage)}>
                      <RemoveIconStyled>delete_forever</RemoveIconStyled>
                    </RemoveIconButton>
                  </DropContainer>
                }
                <UploadButtonContainer>
                  <FileUploader
                    accept='image/*'
                    buttonText="Upload Profile Photo"
                    fileType="image"
                    fullWidth
                    onFinish={this.imageUploadFinished}
                    onProgress={this.updateImageUploadProgress}
                    variant='contained'
                  />
                </UploadButtonContainer>
                { imageUploadProgress > 0 && (
                  <UploadProgressContainer>
                    <LinearProgress variant="determinate" value={imageUploadProgress} />
                  </UploadProgressContainer>
                )}
              </ItemContainer>
            </VideoContainer>
          </StretchContainer>
        </Container>
        <ButtonContainer>
          <ButtonStyled disabled={!dirty} type="submit" color="primary" variant="contained">Save</ButtonStyled>
          <ButtonStyled onClick={onClickCancel} color="secondary" variant="contained">Cancel</ButtonStyled>
        </ButtonContainer>
        <Prompt when={dirty} message={`You have unsaved changes. Are you sure you want to leave?`}/>
      </FormStyled>
    );
  }
};

export default withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
    last: yup.string(),
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    props.submit(values);
    setSubmitting(false);
  },

  displayName: 'BasicForm',
})(ChannelImageForm);
